import Moment from 'moment';
import setAddressTab from './SetAddressTab';
import setBasicInfoTab from './SetBasicInfoTab';
import setContactTab from './SetContactTab';
import setInsuranceTab from './SetInsuranceTab';

const setAllDataInJson = (props,requestJSON) =>{
    requestJSON = setBasicInfoTab(props.basicInfoData,requestJSON,Moment);
    requestJSON = setAddressTab(props.addressData,requestJSON);
    requestJSON = setContactTab(props.contactData,requestJSON);
    requestJSON = setInsuranceTab(props.insuranceData,requestJSON);
    return requestJSON;
}

export default setAllDataInJson